// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

// Types
import { IRootState } from './types';

const initialState: IRootState = {
  members: [],
  isOpenDeleteDialog: false,
  selectedMember: {} as IRootState['selectedMember'],
  isOpenBulkDialog: false,
  shopifyIdToMemberMap: {},
  selectedLocationId: 0,
  activeBulkStep: 0,
  bulkMembers: [],
  isOpenShopifyIdVideo: false,
};

export const slice = createSlice({
  name: STORE_SLICES.TEAM,
  initialState,
  reducers,
});

const memberActions = slice.actions;

const teamPersistConfig = {
  key: PERSIST_KEYS.TEAM,
  storage,
  whitelist: ['members', 'shopifyIdToMemberMap', 'bulkMembers'],
};

export {
  memberActions,
};

export default persistReducer(teamPersistConfig, slice.reducer);
